import request from '@/utils/http';

// 获取验证码
export const getVerificationCodeApi = (params) => {
    return request({
        url: '/api-auth/login/sendVerificationCode',
        method: 'get',
        params: params
    }).then(res => res);
};

// 校验验证码
export const verifyVerificationCode = (params) => {
    return request({
        url: `/api-auth/login/verificationCode?vCode=${params}`,
        method: 'post'
    }).then(res => res);
};
